import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Products from '../components/Products/Products'
import CreateProduct from '../components/Products/CreateProduct'
import EditProduct from '../components/Products/EditProduct'
import Categories from '../components/Categories/Categories'
import CreateCategory from '../components/Categories/CreateCategory'
import EditCategory from '../components/Categories/EditCategory'
import Orders from '../components/Orders/Orders'
import Companies from '../components/Companies/Companies'
import EditCompanyData from '../components/Companies/EditCompanyData'
import Collaborators from '../components/User/Collaborators'
import AuthGuard from './auth-guard'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: { title: 'Adariz - Experto Virtual en Ventas' }
  },
  {
    path: '/products',
    name: 'Products',
    component: Products,
    meta: { title: 'Productos' }
  },
  {
    path: '/company:companyId/product/new',
    name: 'CreateProduct',
    component: CreateProduct,
    props: true,
    beforeEnter: AuthGuard,
    meta: { title: 'Crear nuevo producto' }
  },
  {
    path: '/company:companyId/product/edit:id',
    name: 'EditProduct',
    props: true,
    component: EditProduct,
    meta: { title: 'Editar producto' }
  },
  {
    path: '/categories',
    name: 'Categories',
    component: Categories,
    meta: { title: 'Categorías' }
  },
  {
    path: '/company:companyId/category/new',
    name: 'CreateCategory',
    component: CreateCategory,
    props: true,
    beforeEnter: AuthGuard,
    meta: { title: 'Crear nueva categoría' }
  },
  {
    path: '/company:companyId/category/edit:id',
    name: 'EditCategory',
    props: true,
    component: EditCategory,
    meta: { title: 'Editar categoría' }
  },
  {
    path: '/orders',
    name: 'Orders',
    component: Orders,
    props: true,
    beforeEnter: AuthGuard,
    meta: { title: 'Órdenes de compra' }
  },
  {
    path: '/bots',
    name: 'bots',
    component: Companies,
    meta: { title: 'Bots' }
  },
  {
    path: '/company/companydata/edit',
    name: 'EditCompanyData',
    component: EditCompanyData,
    meta: { title: 'Editar Base de información' }
  },
  { path: '/collaborators',
    name: 'Collaborators',
    component: Collaborators,
    meta: { title: 'Colaboradores' }
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
